import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import common translations
import enCommon from '../locales/en/common.json';
import esCommon from '../locales/es/common.json';
import ptCommon from '../locales/pt/common.json';

// Import all page translations
import enDashboard from '../locales/en/dashboard.json';
import esDashboard from '../locales/es/dashboard.json';
import ptDashboard from '../locales/pt/dashboard.json';

import enProperties from '../locales/en/properties.json';
import esProperties from '../locales/es/properties.json';
import ptProperties from '../locales/pt/properties.json';

import enAssets from '../locales/en/assets.json';
import esAssets from '../locales/es/assets.json';
import ptAssets from '../locales/pt/assets.json';

import enEmployees from '../locales/en/employees.json';
import esEmployees from '../locales/es/employees.json';
import ptEmployees from '../locales/pt/employees.json';

import enResidents from '../locales/en/residents.json';
import esResidents from '../locales/es/residents.json';
import ptResidents from '../locales/pt/residents.json';

import enVendors from '../locales/en/vendors.json';
import esVendors from '../locales/es/vendors.json';
import ptVendors from '../locales/pt/vendors.json';

import enMaintenance from '../locales/en/maintenance.json';
import esMaintenance from '../locales/es/maintenance.json';
import ptMaintenance from '../locales/pt/maintenance.json';

import enNews from '../locales/en/news.json';
import esNews from '../locales/es/news.json';
import ptNews from '../locales/pt/news.json';

import enCalendar from '../locales/en/calendar.json';
import esCalendar from '../locales/es/calendar.json';
import ptCalendar from '../locales/pt/calendar.json';

import enGuidelines from '../locales/en/guidelines.json';
import esGuidelines from '../locales/es/guidelines.json';
import ptGuidelines from '../locales/pt/guidelines.json';

import enExpenses from '../locales/en/expenses.json';
import esExpenses from '../locales/es/expenses.json';
import ptExpenses from '../locales/pt/expenses.json';

import enEmergencyAlerts from '../locales/en/emergencyAlerts.json';
import esEmergencyAlerts from '../locales/es/emergencyAlerts.json';
import ptEmergencyAlerts from '../locales/pt/emergencyAlerts.json';

import enLostAndFound from '../locales/en/lostAndFound.json';
import esLostAndFound from '../locales/es/lostAndFound.json';
import ptLostAndFound from '../locales/pt/lostAndFound.json';

import enIncidentReporting from '../locales/en/incidentReporting.json';
import esIncidentReporting from '../locales/es/incidentReporting.json';
import ptIncidentReporting from '../locales/pt/incidentReporting.json';

import enMessages from '../locales/en/messages.json';
import esMessages from '../locales/es/messages.json';
import ptMessages from '../locales/pt/messages.json';

import enFacilityReservations from '../locales/en/facilityReservations.json';
import esFacilityReservations from '../locales/es/facilityReservations.json';
import ptFacilityReservations from '../locales/pt/facilityReservations.json';

import enVisitorManagement from '../locales/en/visitorManagement.json';
import esVisitorManagement from '../locales/es/visitorManagement.json';
import ptVisitorManagement from '../locales/pt/visitorManagement.json';

import enPackageTracking from '../locales/en/packageTracking.json';
import esPackageTracking from '../locales/es/packageTracking.json';
import ptPackageTracking from '../locales/pt/packageTracking.json';

import enAttendance from '../locales/en/attendance.json';
import esAttendance from '../locales/es/attendance.json';
import ptAttendance from '../locales/pt/attendance.json';

import enTasks from '../locales/en/tasks.json';
import esTasks from '../locales/es/tasks.json';
import ptTasks from '../locales/pt/tasks.json';

import enPayroll from '../locales/en/payroll.json';
import esPayroll from '../locales/es/payroll.json';
import ptPayroll from '../locales/pt/payroll.json';

import enDocuments from '../locales/en/documents.json';
import esDocuments from '../locales/es/documents.json';
import ptDocuments from '../locales/pt/documents.json';

import enWorkspace from '../locales/en/workspace.json';
import esWorkspace from '../locales/es/workspace.json';
import ptWorkspace from '../locales/pt/workspace.json';

import enSettings from '../locales/en/settings.json';
import esSettings from '../locales/es/settings.json';
import ptSettings from '../locales/pt/settings.json';

import enUsers from '../locales/en/users.json';
import esUsers from '../locales/es/users.json';
import ptUsers from '../locales/pt/users.json';

import enAuth from '../locales/en/auth.json';
import esAuth from '../locales/es/auth.json';
import ptAuth from '../locales/pt/auth.json';

import enPayables from '../locales/en/payables.json';
import esPayables from '../locales/es/payables.json';
import ptPayables from '../locales/pt/payables.json';

import enReceivables from '../locales/en/receivables.json';
import esReceivables from '../locales/es/receivables.json';
import ptReceivables from '../locales/pt/receivables.json';

import enAccounting from '../locales/en/accounting.json';
import esAccounting from '../locales/es/accounting.json';
import ptAccounting from '../locales/pt/accounting.json';

import enReceipts from '../locales/en/receipts.json';
import esReceipts from '../locales/es/receipts.json';
import ptReceipts from '../locales/pt/receipts.json';

import enPackages from '../locales/en/packages.json';
import esPackages from '../locales/es/packages.json';
import ptPackages from '../locales/pt/packages.json';

import enReservations from '../locales/en/reservations.json';
import esReservations from '../locales/es/reservations.json';
import ptReservations from '../locales/pt/reservations.json';

import enVisitors from '../locales/en/visitors.json';
import esVisitors from '../locales/es/visitors.json';
import ptVisitors from '../locales/pt/visitors.json';

import enAlerts from '../locales/en/alerts.json';
import esAlerts from '../locales/es/alerts.json';
import ptAlerts from '../locales/pt/alerts.json';

import enNotifications from '../locales/en/notifications.json';
import esNotifications from '../locales/es/notifications.json';
import ptNotifications from '../locales/pt/notifications.json';

import enOnboarding from '../locales/en/onboarding.json';
import esOnboarding from '../locales/es/onboarding.json';
import ptOnboarding from '../locales/pt/onboarding.json';

import enHelp from '../locales/en/help.json';
import esHelp from '../locales/es/help.json';
import ptHelp from '../locales/pt/help.json';

const resources = {
  en: {
    common: enCommon,
    dashboard: enDashboard,
    properties: enProperties,
    assets: enAssets,
    employees: enEmployees,
    residents: enResidents,
    vendors: enVendors,
    maintenance: enMaintenance,
    news: enNews,
    calendar: enCalendar,
    guidelines: enGuidelines,
    expenses: enExpenses,
    emergencyAlerts: enEmergencyAlerts,
    alerts: enAlerts,
    lostAndFound: enLostAndFound,
    incidentReporting: enIncidentReporting,
    messages: enMessages,
    facilityReservations: enFacilityReservations,
    visitorManagement: enVisitorManagement,
    packageTracking: enPackageTracking,
    attendance: enAttendance,
    tasks: enTasks,
    payroll: enPayroll,
    documents: enDocuments,
    workspace: enWorkspace,
    settings: enSettings,
    users: enUsers,
    auth: enAuth,
    payables: enPayables,
    receivables: enReceivables,
    accounting: enAccounting,
    receipts: enReceipts,
    packages: enPackages,
    reservations: enReservations,
    visitors: enVisitors,
    notifications: enNotifications,
    onboarding: enOnboarding,
    help: enHelp,
  },
  es: {
    common: esCommon,
    dashboard: esDashboard,
    properties: esProperties,
    assets: esAssets,
    employees: esEmployees,
    residents: esResidents,
    vendors: esVendors,
    maintenance: esMaintenance,
    news: esNews,
    calendar: esCalendar,
    guidelines: esGuidelines,
    expenses: esExpenses,
    emergencyAlerts: esEmergencyAlerts,
    alerts: esAlerts,
    lostAndFound: esLostAndFound,
    incidentReporting: esIncidentReporting,
    messages: esMessages,
    facilityReservations: esFacilityReservations,
    visitorManagement: esVisitorManagement,
    packageTracking: esPackageTracking,
    attendance: esAttendance,
    tasks: esTasks,
    payroll: esPayroll,
    documents: esDocuments,
    workspace: esWorkspace,
    settings: esSettings,
    users: esUsers,
    auth: esAuth,
    payables: esPayables,
    receivables: esReceivables,
    accounting: esAccounting,
    receipts: esReceipts,
    packages: esPackages,
    reservations: esReservations,
    visitors: esVisitors,
    notifications: esNotifications,
    onboarding: esOnboarding,
    help: esHelp,
  },
  pt: {
    common: ptCommon,
    dashboard: ptDashboard,
    properties: ptProperties,
    assets: ptAssets,
    employees: ptEmployees,
    residents: ptResidents,
    vendors: ptVendors,
    maintenance: ptMaintenance,
    news: ptNews,
    calendar: ptCalendar,
    guidelines: ptGuidelines,
    expenses: ptExpenses,
    emergencyAlerts: ptEmergencyAlerts,
    alerts: ptAlerts,
    lostAndFound: ptLostAndFound,
    incidentReporting: ptIncidentReporting,
    messages: ptMessages,
    facilityReservations: ptFacilityReservations,
    visitorManagement: ptVisitorManagement,
    packageTracking: ptPackageTracking,
    attendance: ptAttendance,
    tasks: ptTasks,
    payroll: ptPayroll,
    documents: ptDocuments,
    workspace: ptWorkspace,
    settings: ptSettings,
    users: ptUsers,
    auth: ptAuth,
    payables: ptPayables,
    receivables: ptReceivables,
    accounting: ptAccounting,
    receipts: ptReceipts,
    packages: ptPackages,
    reservations: ptReservations,
    visitors: ptVisitors,
    notifications: ptNotifications,
    onboarding: ptOnboarding,
    help: ptHelp,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    ns: [
      'common',
      'dashboard',
      'properties',
      'assets',
      'employees',
      'residents',
      'vendors',
      'maintenance',
      'news',
      'calendar',
      'guidelines',
      'expenses',
      'emergencyAlerts',
      'alerts',
      'lostAndFound',
      'incidentReporting',
      'messages',
      'facilityReservations',
      'visitorManagement',
      'packageTracking',
      'attendance',
      'tasks',
      'payroll',
      'documents',
      'workspace',
      'settings',
      'users',
      'auth',
      'payables',
      'receivables',
      'receipts',
      'notifications',
      'onboarding',
      'help',
    ],
    defaultNS: 'common',
    react: {
      useSuspense: false,
    },
  });

export default i18n; 